import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=3e3d4bfb&scoped=true&"
import script from "./CardHeader.vue?vue&type=script&lang=js&"
export * from "./CardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d4bfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3d4bfb')) {
      api.createRecord('3e3d4bfb', component.options)
    } else {
      api.reload('3e3d4bfb', component.options)
    }
    module.hot.accept("./CardHeader.vue?vue&type=template&id=3e3d4bfb&scoped=true&", function () {
      api.rerender('3e3d4bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/card/CardHeader.vue"
export default component.exports